/**
 * Data Pipeline CSV Upload — Frontend ローカル Contract
 *
 * 取り込みパスへの presigned PUT URL を発行する `issueCsvUploadUrl` を定義する。
 * 大容量 CSV を API のリクエストボディ上限に縛られず S3 へ直接 PUT するための経路。
 *
 * BE の `data-pipeline.api-contract.ts` と path / 入力名（pipelineId）を揃えており、
 * `@standandforce/api-contract` の publish 後にそのまま差し替えられる。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
export const inboundDataPipelineCsvContract = oc.router({
  issueCsvUploadUrl: oc.route({
    method: 'POST',
    path: '/v2/data-connector/data-pipelines/{pipelineId}/csv-upload-url'
  }).input(z.object({
    pipelineId: z.string()
  })).output(z.object({
    url: z.string(),
    objectKey: z.string(),
    expiresInSeconds: z.number()
  }))
});